import React, { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { tableStyles } from "../../styles/tableStyles"
import EmployeModalV2 from "./EmployeModalV2"

const styles = {
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 16,
	},
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	count: { fontSize: 13, color: COLORS.textLight },
	empty: {
		...tableStyles.empty,
		padding: "40px 16px",
		color: COLORS.textLight,
		fontSize: 14,
	},
	groupCell: { display: "flex", flexWrap: "wrap", gap: 6 },
	groupChip: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
	},
}

const EmployeRow = ({ emp, index, onDoubleClick }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	const actif = emp.actif
	return (
		<tr
			onDoubleClick={onDoubleClick}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={{ ...tableStyles.td, fontWeight: 500 }}>{emp.nom || "—"}</td>
			<td style={{ ...tableStyles.td, color: COLORS.textMuted }}>
				{emp.username || "—"}
			</td>
			<td style={tableStyles.td}>{emp.tel_mobile || "—"}</td>
			<td style={tableStyles.td}>{emp.email || "—"}</td>
			<td style={tableStyles.td}>
				{emp.groups && emp.groups.length > 0 ? (
					<div style={styles.groupCell}>
						{emp.groups.map((g) => (
							<span key={g} style={styles.groupChip}>
								{g}
							</span>
						))}
					</div>
				) : (
					"—"
				)}
			</td>
			<td style={tableStyles.td}>
				<span
					style={gs.badge(
						actif ? COLORS.success : COLORS.textMuted,
						actif ? COLORS.successLight : COLORS.bg,
					)}
				>
					{actif ? "Actif" : "Inactif"}
				</span>
			</td>
		</tr>
	)
}

const EmployesRH = () => {
	const employes = useSelector((s) => s.masterReducer.employes)
	const [editing, setEditing] = useState(null)
	const sorted = useMemo(
		() =>
			[...(employes || [])].sort(
				(a, b) =>
					Number(b.actif) - Number(a.actif) ||
					(a.nom_famille || "").localeCompare(
						b.nom_famille || "",
						"fr",
					) ||
					(a.prenom || "").localeCompare(b.prenom || "", "fr"),
			),
		[employes],
	)

	return (
		<>
			{editing && (
				<EmployeModalV2
					employe={editing}
					onClose={() => setEditing(null)}
				/>
			)}
			<div style={styles.header}>
				<div
					style={{ display: "flex", alignItems: "baseline", gap: 10 }}
				>
					<span style={styles.title}>Employés</span>
					<span style={styles.count}>{sorted.length}</span>
				</div>
				<button
					style={gs.btnPrimary}
					onClick={() => setEditing({})}
				>
					+ Nouvel employé
				</button>
			</div>
			<div style={tableStyles.container}>
				{sorted.length === 0 ? (
					<div style={styles.empty}>Aucun employé.</div>
				) : (
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Nom</th>
								<th style={tableStyles.th}>Identifiant</th>
								<th style={tableStyles.th}>Téléphone</th>
								<th style={tableStyles.th}>E-mail</th>
								<th style={tableStyles.th}>Groupes</th>
								<th style={tableStyles.th}>Statut</th>
							</tr>
						</thead>
						<tbody>
							{sorted.map((emp, index) => (
								<EmployeRow
									key={emp.id}
									emp={emp}
									index={index}
									onDoubleClick={() => setEditing(emp)}
								/>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	)
}

export default EmployesRH
